module.exports = __webpack_public_path__ + "static/media/bye.938f96a6.png";